import { render } from "./EdufideTemplate.vue?vue&type=template&id=43cbe566"
import script from "./EdufideTemplate.vue?vue&type=script&lang=js"
export * from "./EdufideTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__